import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { SplashScreenService } from '../../services/splash-screen/splash-screen.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [AsyncPipe, SvgIconComponent],
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('300ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class SplashScreenComponent {
  splashScreenService = inject(SplashScreenService);
  isShowing$ = this.splashScreenService.isShowing$;
  message$ = this.splashScreenService.message$;
}
